import fetch, { toQueryString } from '../fetch';
import config from '../../config';

const BillingAPI = () => {
  const endpoint = `${config.apiUrl}/v1/billing`;

  const getCreditCardList = async (orgId, query, options = {}, ctx = {}) => {
    const queryString = toQueryString(query);
    try {
      return await fetch(`${endpoint}/org/${orgId}/credit-card-list${queryString}`, {
        method: 'GET',
        ...options,
        ctx,
      });
    } catch (error) {
      return error;
    }
  };

  const createCreditCard = async (requestBody, options = {}) => {
    try {
      return await fetch(`${endpoint}/card`, {
        method: 'POST',
        body: requestBody,
        ...options,
      });
    } catch (error) {
      return { error };
    }
  };

  const getCardSubOrganizations = async (organizationId, options = {}) => {
    try {
      return await fetch(`${endpoint}/org/${organizationId}/sub-org`, {
        method: 'GET',
        ...options,
      });
    } catch (error) {
      return { error };
    }
  };

  const getSingleCreditCard = async (cardId, options = {}, ctx = {}) => {
    try {
      return await fetch(`${endpoint}/card/${cardId}`, {
        method: 'GET',
        ...options,
        ctx,
      });
    } catch (error) {
      return error;
    }
  };

  const deleteSingleCreditCard = async (cardId, options = {}, ctx = {}) => {
    try {
      return await fetch(`${endpoint}/card/${cardId}`, {
        method: 'DELETE',
        ...options,
        ctx,
      });
    } catch (error) {
      return error;
    }
  };

  const creditCardSubOrganizations = async (organizationId, requestBody, options = {}) => {
    try {
      return await fetch(`${endpoint}/org/${organizationId}/sub-org`, {
        method: 'POST',
        body: requestBody,
        ...options,
      });
    } catch (error) {
      return { error };
    }
  };

  const getCreditCardSubOrganizations = async (organizationId, cardId, options = {}, ctx = {}) => {
    try {
      return await fetch(`${endpoint}/org/${organizationId}/card/${cardId}/sub-org`, {
        method: 'GET',
        ...options,
        ctx,
      });
    } catch (error) {
      return { error };
    }
  };

  const getTransactionsList = async (orgId, query, options = {}, ctx = {}) => {
    const queryString = toQueryString(query);
    try {
      return await fetch(`${endpoint}/org/${orgId}/transaction${queryString}`, {
        method: 'GET',
        ...options,
        ctx,
      });
    } catch (error) {
      return error;
    }
  };

  const getCreditCardSummary = async (organizationId) => {
    const baseUrl = `${config.apiUrl}/v1/billing/org/${organizationId}/credit_card_summary`;
    try {
      const response = await fetch(baseUrl, { method: 'GET' });
      return response?.data;
    } catch (error) {
      throw error;
    }
  };

  const getDeclinedTransactions = async (query) => {
    const queryString = toQueryString(query);
    const baseUrl = `${endpoint}/declined${queryString}`;
    try {
      const response = await fetch(baseUrl, { method: 'GET' });
      return response;
    } catch (error) {
      throw error;
    }
  };

  return {
    createCreditCard,
    creditCardSubOrganizations,
    getCardSubOrganizations,
    getCreditCardList,
    getTransactionsList,
    getCreditCardSubOrganizations,
    getSingleCreditCard,
    deleteSingleCreditCard,
    getCreditCardSummary,
    getDeclinedTransactions,
  };
};

export default BillingAPI;
